<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created: function() {
    document.body.removeChild(document.getElementById('loader'));
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
</style>
